import VueX from '@/store';

/*
 * Much+ plans are global (they apply to all of Delivery Much), so the
 * section is exclusive to the Franchisor panel.
 */
export default (to, from, next,) => {
  const redirect = to.name.indexOf('franchise',) < 0 ? '/franquias' : '/franquia';
  if (VueX.getters['user/user']?.businessType !== 'Franqueadora') {
    next(redirect,);
  } else {
    next();
  }
};
